
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CrmAPI } from '../MyAppCommonConfig';

@Injectable({providedIn: 'root'})
export class RepairRequestService {

    private authMobileUrl: string = 'Product/AuthMobile';
    private verifyCodeUrl: string = 'Product/VerifyCode';
    private saveRequestUrl: string = 'RepairRequestHandler/Save';
    private pay: string = 'Payment/Pay';
    private verify: string = 'Payment/Verify';
    private savePollingUrl: string = 'RepairRequestHandler/SavePolling';

    constructor(private http: HttpClient) { }
    
    authMobile(serialNumber: string) {
        return this.http.get(`${CrmAPI}/${this.authMobileUrl}?serialNumber=${serialNumber}`);
    }

    verifyCode(serialNumber: string, code: string) {
        return this.http.post(`${CrmAPI}/${this.verifyCodeUrl}?code=${code}&serialNumber=${serialNumber}`, null);
    }

    saveRequest(requestModel: any) {
        return this.http.post(`${CrmAPI}/${this.saveRequestUrl}`, requestModel);
    }

    beginPayment(requestId: string) {
        return this.http.get(`${CrmAPI}/${this.pay}?codeVorrodDastgah=${requestId}`);
    }

    verifyPayment(authority: string) {
        return this.http.post(`${CrmAPI}/${this.verify}?authority=${authority}`, null);
    }
    
    savePolling(saveModel: any) {
        return this.http.post(`${CrmAPI}/${this.savePollingUrl}`, saveModel);
    }
}